module.exports = __webpack_public_path__ + "img/about-icon-01.69aec1b7.svg";